import * as Application from 'expo-application';
import Constants from 'expo-constants';
import * as Device from 'expo-device';
import { getLocales } from 'expo-localization';
import { useEffect, useState } from 'react';
import { Platform } from 'react-native';

import { getBaseURL } from 'app/services/GuestCenterService';
import HeapAnalytics from 'app/services/HeapAnalytics';
import HygraphService from 'app/services/HygraphService';
import Logger from 'app/services/Logger';

const hygraphService = HygraphService();

// workaround for minified web class names being stripped, fixed in SDK 53+
// see https://github.com/expo/expo/issues/34777
let Updates: {
  runtimeVersion: string | null;
  updateId: string | null;
  channel: string | null;
  isUsingEmbeddedAssets: boolean;
};
if (Platform.OS !== 'web') {
  // eslint-disable-next-line global-require
  Updates = require('expo-updates');
}

export default function useDebugInfo() {
  const [deviceType, setDeviceType] = useState(Device.DeviceType[0]);
  const [heapUserId, setHeapUserId] = useState('');
  const locale = getLocales()[0]?.languageCode ?? '';

  useEffect(() => {
    Device.getDeviceTypeAsync().then((type) => setDeviceType(Device.DeviceType[type]));

    try {
      HeapAnalytics.getUserId().then((userId) => {
        setHeapUserId(userId);
      });
    } catch (e) {
      Logger.error('[useDebugInfo] Error getting Heap user ID', { error: e });
    }
  }, []);

  function toTitleCase(txt: string): string {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  }

  return {
    commit: Constants.expoConfig?.extra?.commit,
    profile: Constants.expoConfig?.extra?.profile,
    buildid: Constants.expoConfig?.extra?.buildid,
    appVersion: Constants.expoConfig?.version,
    nativeAppVersion: Application.nativeApplicationVersion,
    nativeBuildVersion: Application.nativeBuildVersion,
    runtimeVersion: Updates?.runtimeVersion,
    updateId: Updates?.updateId,
    channel: Updates?.channel,
    isUsingEmbeddedAssets: Updates?.isUsingEmbeddedAssets,
    expoVersion: Constants.expoVersion,
    sdkVersion: Constants.expoConfig?.sdkVersion,
    guestCenterTarget: getBaseURL(),
    hygraphApiURL: hygraphService.client.url,
    mode: __DEV__ ? 'development' : 'production',
    platform: Platform.OS,
    platformName: Platform.OS === 'ios' ? 'iOS' : toTitleCase(Platform.OS),
    deviceOS: `${Device.osName} ${Device.osVersion}`,
    deviceType,
    deviceTypeName: toTitleCase(deviceType || ''),
    deviceLanguage: locale.substring(0, 2),
    manufacturer: Device.manufacturer,
    model: Device.modelName,
    sessionId: Constants.sessionId,
    heapUserId,
  };
}
